@if (codesDangerousSubstances && codesDangerousSubstances.length > 0) { @if (!isPackaging) {
<span class="dangerous-substances" i18n="@@hermes.environment.dangeroussubstances.description"
    >Cet article contient au moins une substance qualifiée d'extrêmement par l'Agence Européenne des produits chimiques
    :</span
>
} @if (isPackaging) {
<span class="dangerous-substances" i18n="@@hermes.environment.dangeroussubstancespackaging.description"
    >L’emballage de cet article contient au moins une substance qualifiée d’« extrêmement préoccupante » par l'Agence
    Européenne des produits chimiques :</span
>
}
<ul class="data">
    @for (code of this.codesDangerousSubstances; track code) {
    <li>
        @switch (code) { @case ('VAL_01') {

        <span i18n="@@hermes.environment.dangeroussubstances.val01.title"> Plomb </span>@if (isDescriptionDisplay$ |
        async) {
        <span>
            :<span
                class="data-description"
                [attr.data-code]="code"
                i18n="@@hermes.environment.dangeroussubstances.val01.description">
                (Cette substance est présente dans des parties internes de l'article qui ne sont pas accessibles lors
                d’une utilisation normale de l'objet.)</span
            ></span
        >
        } } @case ('VAL_02') {

        <span i18n="@@hermes.environment.dangeroussubstances.val02.title"> 1,3- propane sultone </span>
        @if (isDescriptionDisplay$ | async) {
        <span>
            :<span
                class="data-description"
                [attr.data-code]="code"
                i18n="@@hermes.environment.dangeroussubstances.val02.description">
                (Cette substance est présente dans des parties internes de la batterie qui ne sont pas accessibles lors
                d'une utilisation normale de l'objet.)</span
            ></span
        >
        } } @case ('VAL_03') {

        <span i18n="@@hermes.environment.dangeroussubstances.val03.title"> 4,4'-sulfonyldiphenol</span>@if
        (isDescriptionDisplay$ | async) {
        <span>
            :<span
                class="data-description"
                [attr.data-code]="code"
                i18n="@@hermes.environment.dangeroussubstances.val03.description">
                (Cette substance est traditionnellement utilisée par l’industrie du tannage pour ses propriétés
                sensorielles apportées au cuir. Le groupe HERMES travaille activement sur ces sujets dans une optique
                d’amélioration constante et met tout en œuvre pour supprimer ou réduire significativement la teneur de
                cette substance.)</span
            ></span
        >
        } } @case ('VAL_04') {

        <span i18n="@@hermes.environment.dangeroussubstances.val04.title"> 1,2-dimethoxyethane</span>@if
        (isDescriptionDisplay$ | async) {
        <span>
            :<span
                class="data-description"
                [attr.data-code]="code"
                i18n="@@hermes.environment.dangeroussubstances.val04.description">
                (Cette substance est présente dans des parties internes de la batterie qui ne sont pas accessibles lors
                d'une utilisation normale de l'objet.)</span
            ></span
        >
        } } @case ('VAL_05') {

        <span i18n="@@hermes.environment.dangeroussubstances.val05.title"> Cyclopentasiloxane (CAS Nr : 541-02-6)</span>
        @if ((isDescriptionDisplay$ | async) && hasVal05Description) {
        <span>
            :<span
                class="data-description"
                [attr.data-code]="code"
                i18n="@@hermes.environment.dangeroussubstances.val05.description">
                ()</span
            ></span
        >
        } } }
    </li>
    }
</ul>

}
